import { clsx } from "clsx";
import { X } from "lucide-react";
import { useSidebarStore } from "@/hooks/useSidebar";
import { SidebarBrand } from "./SidebarBrand";
import { SidebarNav } from "./SidebarNav";

export function MobileSidebarOverlay() {
  const isMobileOpen = useSidebarStore((s) => s.isMobileOpen);
  const closeMobile = useSidebarStore((s) => s.closeMobile);

  return (
    <div className={clsx("lg:hidden", !isMobileOpen && "pointer-events-none")}>
      {/* Backdrop */}
      <div
        className={clsx(
          "fixed inset-0 z-40 bg-black/50 transition-opacity duration-300",
          isMobileOpen ? "opacity-100" : "opacity-0",
        )}
        onClick={closeMobile}
        aria-hidden="true"
      />

      {/* Slide-in sidebar */}
      <aside
        className={clsx(
          "fixed inset-y-0 left-0 z-50 flex w-60 flex-col bg-adara-800 text-white",
          "transition-transform duration-300",
          isMobileOpen ? "translate-x-0" : "-translate-x-full",
        )}
      >
        {/* Header with close button */}
        <div className="flex h-14 shrink-0 items-center justify-between border-b border-white/10 px-5">
          <SidebarBrand />
          <button
            type="button"
            onClick={closeMobile}
            className="cursor-pointer rounded-lg p-1.5 text-white/50 transition-colors hover:bg-white/5 hover:text-white"
            aria-label="Zamknij menu"
          >
            <X size={20} aria-hidden="true" />
          </button>
        </div>

        {/* Navigation */}
        <SidebarNav />
      </aside>
    </div>
  );
}
